import React from 'react';
import classes from './storeCheckoutLocatorModal.css';
import StoreCheckoutModalPagination from './storeCheckoutModalPagination';
import AvailableIcon from '../../AvailableIcon/availableIcon';
import { useIntl } from 'react-intl';
import { sendGTMEvent } from "../../../util/initGTM";
import { useHistory } from 'react-router-dom';
import ScheduleTimeContainer from "./scheduleTimeContainer";
import StoreBopisAvailability from "./storeBopisAvailability";
import StoreActionButtons from "./storeActionButtons";
import StokesThinkkithenContainer from "./stokesThinkkithenContainer";
import { useStoreSwitcher } from "@magento/peregrine/lib/talons/Header/useStoreSwitcher";
var StoreList = _ref => {
  var {
    storesStock,
    setOpenInfoWindow,
    closeModal,
    setCurrentPage,
    setCurrentGroupPage,
    currentPage,
    currentGroupPage,
    paginationStores,
    isDetailedStock,
    infiniteScroll,
    forceAllStores,
    fromPage
  } = _ref;
  var history = useHistory();
  var {
    formatMessage
  } = useIntl();
  var {
    currentStoreCode
  } = useStoreSwitcher();
  var STATIC_STRINGS = {
    km: 'km',
    inStock: formatMessage({
      defaultMessage: 'In Stock',
      id: 'productDetail.inStock'
    }),
    outOfStock: formatMessage({
      defaultMessage: 'Out of Stock',
      id: 'productDetail.outOfStock'
    }),
    unitsInStock: formatMessage({
      id: "productDetail.unitsInStock",
      defaultMessage: 'units in stock'
    }),
    unitInStock: formatMessage({
      id: "productDetail.unitInStock",
      defaultMessage: 'unit in stock'
    }),
    pickupAvailable: formatMessage({
      defaultMessage: 'Pickup in store available',
      id: 'productDetail.pickupAvailable'
    }),
    pickupNotAvailable: formatMessage({
      defaultMessage: 'Not available for pickup in store',
      id: 'productDetail.pickupNotAvailable'
    })
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.storesListOuterContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.storesList
  }, storesStock === null || storesStock === void 0 ? void 0 : storesStock.map(store => {
    var {
      address,
      city,
      region,
      country,
      zipcode,
      is_active,
      inStock,
      bopis_enabled,
      marker,
      is_thinkkitchen,
      storeProductsQuantities,
      store_id
    } = store;
    var location = "".concat(address, ", ").concat(city, ", ").concat(region, ", ").concat(zipcode, ", ").concat(country);
    if (!is_active) return null;
    var stockUnitsQty = storeProductsQuantities && storeProductsQuantities.length && storeProductsQuantities[0].productInStoreInventoryQty;
    return /*#__PURE__*/React.createElement("div", {
      key: store_id,
      className: classes.storeContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.storeHeader
    }, /*#__PURE__*/React.createElement(StokesThinkkithenContainer, {
      is_thinkkitchen: is_thinkkitchen,
      name: store.name
    }), store.distance && /*#__PURE__*/React.createElement("div", {
      className: classes.kmContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.distanceValue
    }, store.distance), /*#__PURE__*/React.createElement("div", null, STATIC_STRINGS.km))), /*#__PURE__*/React.createElement("button", {
      className: classes.storeName,
      onClick: () => {
        setOpenInfoWindow(store);
        history.push("/".concat(currentStoreCode === 'en' ? 'store' : 'magasin', "?").concat(store.name.replace(' ', '-'), "&code=").concat(store.code));
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.indexMarker
    }, marker), store.name), /*#__PURE__*/React.createElement("div", {
      className: classes.location
    }, location), /*#__PURE__*/React.createElement("a", {
      href: "tel:".concat(store.phone),
      className: classes.phone,
      onClick: () => {
        switch (fromPage) {
          case 'checkout':
            {
              sendGTMEvent({
                eventCategory: 'checkout step 4.1.1 - select a store',
                eventAction: 'Select Other Store Overlay',
                eventLabel: "".concat(store.name, " - call"),
                event: 'genericGAEvent'
              });
              break;
            }
        }
      }
    }, store.phone), /*#__PURE__*/React.createElement(ScheduleTimeContainer, {
      fromPage: fromPage,
      store: store
    }), forceAllStores ? /*#__PURE__*/React.createElement(StoreBopisAvailability, {
      bopis_enabled: bopis_enabled
    }) : isDetailedStock && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.checkSection
    }, inStock ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: classes.storeQuantitySectionCheck
    }, /*#__PURE__*/React.createElement(AvailableIcon, {
      type: 'check'
    }), stockUnitsQty == 1 ? /*#__PURE__*/React.createElement("span", null, "".concat(stockUnitsQty, " ").concat(STATIC_STRINGS.unitInStock)) : /*#__PURE__*/React.createElement("span", null, "".concat(stockUnitsQty, " ").concat(STATIC_STRINGS.unitsInStock)))) : /*#__PURE__*/React.createElement("div", {
      className: classes.checkingContainer
    }, /*#__PURE__*/React.createElement(AvailableIcon, {
      type: 'unavailable'
    }), /*#__PURE__*/React.createElement("span", null, STATIC_STRINGS.outOfStock)))), /*#__PURE__*/React.createElement(StoreActionButtons, {
      store: store,
      fromPage: fromPage,
      setOpenInfoWindow: setOpenInfoWindow,
      closeModal: closeModal,
      inStock: inStock
    }), !isDetailedStock && /*#__PURE__*/React.createElement("div", {
      className: classes.checkingContainerLast
    }, inStock ? /*#__PURE__*/React.createElement(AvailableIcon, {
      type: 'check'
    }) : /*#__PURE__*/React.createElement(AvailableIcon, {
      type: 'unavailable'
    }), inStock ? STATIC_STRINGS.inStock : STATIC_STRINGS.outOfStock));
  })), !infiniteScroll && /*#__PURE__*/React.createElement(StoreCheckoutModalPagination, {
    currentPage: currentPage,
    setCurrentPage: setCurrentPage,
    paginationStores: paginationStores,
    setCurrentGroupPage: setCurrentGroupPage,
    currentGroupPage: currentGroupPage,
    classes: classes
  }));
};
export default StoreList;